import { Component, ElementRef, inject, Inject, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CompleteRegistrationComponent } from './completeRegistration.component';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from '@auth0/auth0-angular';


@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  constructor(
    private userService: UserService,     
    public auth: AuthService
  ) {} 

  ngOnInit() {
      sessionStorage.setItem('loggedIn', 'true');
      this.auth.loginWithRedirect({
        authorizationParams: {
          screen_hint: "signup",
        }
      });
  }
}
